import { useState } from "react";
import { Navigate } from "react-router-dom";
import { AppWindow, CreditCard, FolderKanban, Server } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { DashShell, FullLoader } from "@/pages/admin/AdminLayout";

// Add { to: "/portal/invoices", label: "Invoices", ... } here in phase 3.
const ITEMS = [
  { to: "/portal", label: "My projects", icon: FolderKanban, id: "projects", end: true },
  { to: "/portal/payments", label: "Payments", icon: CreditCard, id: "payments" },
  { to: "/portal/apps", label: "My apps", icon: AppWindow, id: "apps" },
  { to: "/portal/hosting", label: "Hosting", icon: Server, id: "hosting" },
];

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const [loggedOut, setLoggedOut] = useState(false);
  const doLogout = async () => { await logout(); setLoggedOut(true); };

  if (loggedOut) return <Navigate to="/login" replace />;
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin/projects" replace />;
  return <DashShell items={ITEMS} user={user} logout={doLogout} home="/portal" prefix="portal" />;
}
